const filter = () => {
  const init = () => {
    // Event listener
    const filterByElem = document.querySelector('.orderBy');
    if (filterByElem) {
      filterByElem.addEventListener('change', handleChange);
    }

    jQuery(document).ready(function($) {
      $('.pcd-category-container .pcd-select option[value="15"]').remove();
    });
  };

  const getAll = () => {
    const productsList = document.querySelectorAll('article.product');
    let products = [];
    for (let i = 0; i < productsList.length; i += 1) {
      products[i] = {
        name: productsList[i].querySelector('.title').innerHTML,
        image: productsList[i].querySelector('figure img').src,
        desc: productsList[i].querySelector('p').innerHTML,
        note: productsList[i].querySelector('.note').innerHTML,
        url: productsList[i].querySelector('a').href,
        price: parseFloat((productsList[i].querySelector('.price').textContent).replace(/[,]/g, '.'), 2),
      };
    }
    return products;
  };
  
  const handleChange = (e) => {
    const allProducts = getAll();
    filterBy(allProducts, e.target.value);
  };

  const insert = (product) => {
    // Parent
    const parentElement = document.createElement('article');
    parentElement.classList.add('product');

    // Image
    const figureElement = document.createElement('figure');
    const imgElement = document.createElement('img');
    imgElement.src = product.image;
    imgElement.classList.add('attachment-woocommerce_thumbnail');
    imgElement.classList.add('size-woocommerce_thumbnail');
    imgElement.alt = '';
    figureElement.append(imgElement);

    // Title
    const titleElement = document.createElement('strong');
    titleElement.classList.add('title');
    titleElement.innerHTML = product.name;

    // Desc
    const pElement = document.createElement('p');
    pElement.innerHTML = product.desc;

    // Note
    const noteElement = document.createElement('span');
    noteElement.classList.add('note');
    noteElement.innerHTML = product.note;

    // Button
    const buttonElement = document.createElement('a');
    buttonElement.classList.add('btn');
    buttonElement.href = product.url;
    buttonElement.textContent = 'Découvrir';

    // AppendChilds
    parentElement.append(figureElement);
    parentElement.append(titleElement);
    parentElement.append(pElement);
    parentElement.append(noteElement);
    parentElement.append(buttonElement);

    // Insert
    const gridElement = document.querySelector('.grid');
    gridElement.append(parentElement);
  };

  const update = (products) => {
    const gridElement = document.querySelector('.grid');
    gridElement.innerHTML = '';
    products.map(current => insert(current));
  };
  
  const filterBy = (products, order) => {
    const sorted = products.sort((a,b) => {
      console.log(a.name);
      // (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
    });
    const sortedPrice = products.sort((a,b) => (a.price > b.price) ? 1 : ((b.price > a.price) ? -1 : 0));
    console.error('products:', products, 'sortedPrice:', sortedPrice);

    switch (order) {
      case 'ASC':
        update(sorted);
        break;
      case 'DESC':
        update(sorted.reverse());
        break;
      case 'minusToPlus':
        update(sortedPrice);
        break;
      case 'plusToMinus':
        update(sortedPrice.reverse());
        break;
      default:
        return console.warn('Can\'t manage to order the products list');
    }
  };

  init();
}

export { filter };
